import Swiper from "swiper/dist/js/swiper";
import template from "./../templates/thumbslider.dust";

export default class ThumbSlider {
  pages = null;

  DOMContainer = null;

  isCentered = false;
  min = null;
  max = null;

  imageSizes = null;

  constructor(appState, pages, sizes) {
    this.appState = appState;
    this.pages = pages;
    this.sizes = sizes;
    this.DOMContainer = document.querySelector(
      "#app-container .reader-thumbs-slider"
    );

    this.setThumbsCategories();
    this.render();
  }

  load() {
    this.canLoad = true;
    if (this.isRendered) {
      this.renderThumbs();
    }
  }

  renderThumbs() {
    const promises = [];
    const slides = this.DOMContainer.querySelectorAll(".slide-thumb");
    for (let i = 0; i < slides.length; i++) {
      const pageId = "#page_" + i + "_thumb";
      const element = this.DOMContainer.querySelector(pageId);
      promises.push(
        this.appState.cdnAssetsDownloader.loadBackgroundPreviewOnElement(
          this.sizes,
          this.pages[i].PublicationPageID,
          element
        )
      );
    }
    if (!Promise.allSettled) return;
    Promise.allSettled(promises).then(this.resize.bind(this));
  }

  setThumbsCategories() {
    const categories = [];
    // create all thumb image url's
    for (let x = 0; x < this.pages.length; x++) {
      const page = this.pages[x];
      page.thumbId = "page_" + x + "_thumb";
      if (categories.indexOf(page.PageCategory) === -1) {
        categories.push(page.PageCategory);
        page.thumbCategory = page.PageCategory;
      }
    }
  }

  render() {
    const context = {};
    context.pages = this.pages.map(this._adjustPageNumber.bind(this));

    Dust.render(template, context, (err, result) => {
      this.DOMContainer.innerHTML = result;
      this.createSwiper();
      this.isRendered = true;
      if (this.canLoad) {
        this.renderThumbs();
      }
    });
  }

  loadThumbs() {
    //load thumbs in advance
    this.pages.forEach((page) => {
      const image = new Image();
      image.src = page.thumbUrl;
    });
  }

  createSwiper() {
    this.show();
    const slideWidth =
      this.DOMContainer.querySelector(
        ".slide-container"
      ).getBoundingClientRect().width;
    const totalWidth = this.DOMContainer.getBoundingClientRect().width;

    const number = totalWidth / slideWidth;

    this.swiper = new Swiper(".swiper-container-thumbs", {
      initialSlide: 0,
      slidesPerView: number,
      centeredSlides: false,
    });

    this.hide();

    this.min = Math.floor(Math.floor(number) / 2);
    this.max = this.swiper.slides.length - 1 - this.min;

    this.moveToPage(this.appState.currentPage);
  }

  resize() {
    this.show();
    const slideWidth =
      this.DOMContainer.querySelector(
        ".slide-container"
      ).getBoundingClientRect().width;
    const totalWidth = this.DOMContainer.getBoundingClientRect().width;

    const number = totalWidth / slideWidth;

    this.swiper.params.slidesPerView = number;
    this.swiper.update();

    this.hide();

    this.min = Math.floor(Math.floor(number) / 2);
    this.max = this.swiper.slides.length - 1 - this.min;

    this.moveToPage(this.appState.currentPage);
  }

  hide() {
    this.DOMContainer.classList.add("hidden");
  }

  show() {
    this.DOMContainer.classList.remove("hidden");
  }

  moveToPage(index) {
    let realIndex = Math.min(index, this.appState.totalPages - 1);
    realIndex = Math.max(realIndex, 0);
    this.deActivateAllSlides();
    if (this.min < realIndex && realIndex < this.max) {
      if (!this.isCentered) {
        this.isCentered = true;
        this.swiper.params.centeredSlides = true;
        this.swiper.update();
      }
      this.swiper.slideTo(realIndex);
      this.swiper.slides[realIndex].classList.add("active");
    } else {
      if (this.isCentered) {
        this.isCentered = false;
        this.swiper.params.centeredSlides = false;
        this.swiper.update();
      }
      if (realIndex <= this.min) {
        this.swiper.slideTo(0);
        this.swiper.slides[0].classList.remove("active");
        this.swiper.slides[realIndex].classList.add("active");
      } else if (realIndex >= this.max) {
        this.swiper.slideTo(this.swiper.slides.length - 1);
        this.swiper.slides[this.swiper.slides.length - 1].classList.remove(
          "active"
        );
        this.swiper.slides[realIndex].classList.add("active");
      }
    }
  }

  deActivateAllSlides() {
    $(this.swiper.slides).removeClass("active");
  }

  destroy() {
    this.swiper.removeAllSlides();
    this.swiper.destroy();
    this.DOMContainer.innerHTML = "";
    this.swiper = null;
    this.DOMContainer = null;
  }

  _adjustPageNumber(page) {
    page.ajustedPageNumber =
      page.adjustedIndex !== undefined
        ? page.adjustedIndex + 1
        : page.PageNumber;
    return page;
  }
}



// WEBPACK FOOTER //
// ./src/common/components/thumbsliderswiper.js